import { Modal, Checkbox } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

export default function OrdersGridAddOnsModal({
  isAddOnsOpen,
  handleClose,
  onHandleAddOnsOkButton,
  foodAddOns,
  selectedAddOns
}) {

  const [tempSelectedAddOns, setTempSelectedAddOns] = useState([]);

  useEffect(() => {
    if (Boolean(selectedAddOns) && selectedAddOns.length > 0) {
      setTempSelectedAddOns([...selectedAddOns]);
    } else {
      setTempSelectedAddOns([]);
    }
    
  }, [selectedAddOns]);

  function onHandleAddOns(e, val) {
    if (e.target.checked) {
      setTempSelectedAddOns(prev => {
        if (!prev.some(addOn => addOn.id === val.id)) {
          return [...prev, val];
        }
        return prev;
      });
    } else {
      setTempSelectedAddOns(prev => prev.filter(addOn => addOn.id !== val.id));
    }
  }

  function onHandleCancelModal() {
    setTempSelectedAddOns([...selectedAddOns]);
    handleClose(false);
  }

  function onHandleAdd() {
    onHandleAddOnsOkButton(tempSelectedAddOns);
    handleClose(false);
  }

  return (
    <Modal
      open={isAddOnsOpen}
      footer={[
        <div key='footer-btns' className="flex gap-x-5 justify-center py-[58px]">
          <button
            key='cancel-btn'
            onClick={onHandleCancelModal}
            className="bg-[#FCBD10] text-black text-[14px] font-bold leading-[16px] w-[100px] h-[42px] rounded-[5px]"
          >
            Cancel
          </button>
          <button
            key='add-btn'
            onClick={onHandleAdd}
            className="bg-[#2EC114] text-white text-[14px] font-bold leading-[16px] w-[100px] h-[42px] rounded-[5px]"
          >
            Add
          </button>
        </div>
      ]}
      onCancel={onHandleCancelModal}
      width={550}
      style={{ padding: "40px" }}
      className="add-ons-modal"
      okText="Add"
      cancelText="Cancel"
      title={<h1 className="uppercase bg-[#E5E5E5] py-5 pl-[30px]">Add-Ons</h1>}
      destroyOnClose={true}
      closeIcon={<CloseCircleOutlined className="text-black text-[24px]" />}
    >
      <section className="min-h-[50px] bg-white mt-[42px]">
        {/* add-ons items */}
        {foodAddOns?.map((addOn, idx) => {
            return (
            <div
              key={addOn.id + idx}
              className="flex items-center justify-between px-[32px] mb-[15px]"
            >
              <Checkbox
              checked={tempSelectedAddOns.some(el => el.id === addOn.id)}
              onChange={(e) => onHandleAddOns(e, addOn)}
              className="add-ons-modal-checkbox"
              >
              <h1 className="text-[12px] font-medium leading-[13px]  break-all min-w-0">
                {addOn.name}
              </h1>
              </Checkbox>
              <p className="shrink-0">{Number(addOn.price).toFixed(2)} TK</p>
            </div>
            );
        })}
      </section>
    </Modal>
  );
}
